import { images } from "../constants";

const home = [
    {
        id: 1,
        image: images.home1,
        subtitle: "home.slider.0.subtitle",
        headingPart1: "home.slider.0.headingPart1",
        spanText: "home.slider.0.spanText",
        headingPart2: "home.slider.0.headingPart2",
        buttonText: "home.slider.0.buttonText",
        buttonLink: 'Skontaktuj-sie'
    },
    {
        id: 2,
        image: images.home2,
        subtitle: "home.slider.1.subtitle",
        headingPart1: "home.slider.1.headingPart1",
        spanText: "home.slider.1.spanText",
        headingPart2: "home.slider.1.headingPart2",
        buttonText: "home.slider.1.buttonText",
        buttonLink: 'Skontaktuj-sie'
    },
    {
        id: 3,
        image: images.home3,
        subtitle: "home.slider.2.subtitle",
        headingPart1: "home.slider.2.headingPart1",
        spanText: "home.slider.2.spanText",
        headingPart2: "home.slider.2.headingPart2",
        buttonText: "home.slider.2.buttonText",
        buttonLink: 'Skontaktuj-sie'
    },
];

export default home;